import classnames from 'classnames';
import React from 'react';

const findNamePortionRegex = /(\w)+/;

export const splitPrintedTypeString = (printedType: string) => {
  const typeNamePart = findNamePortionRegex.exec(printedType)?.[0] || null;
  if (!typeNamePart) {
    return [printedType];
  }
  const [symbolsBeforeNamePart = '', symbolsAfterNamePart = ''] =
    printedType.split(typeNamePart);
  return [symbolsBeforeNamePart, typeNamePart, symbolsAfterNamePart];
};

export const FormattedTypeString = ({
  typeString,
  typeNamePartClassName,
  className,
}: {
  typeString: string;
  // only applies to the typeName
  typeNamePartClassName: string;
  // applies to each part (including the !)
  className?: string;
}) => {
  return (
    <>
      {splitPrintedTypeString(typeString).map((segment, i, segments) => (
        <span
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          className={classnames(
            {
              [typeNamePartClassName]: segments.length === 1 || i === 1,
            },
            className,
          )}
        >
          {segment}
        </span>
      ))}
    </>
  );
};
